import {Button, Divider, FormControl, Grid, InputLabel, MenuItem, Select} from "@material-ui/core";
import UniDialog from '../../Common/UniDialog';
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {getUserPreference} from "../../../utilities/common";
import {updateBatchPayroll} from "../../../actions/payRollAdjustmentAction";

function SelectPayrollDialog(props) {
    const {t} = useTranslation('payrollAdjustment');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const [payrollCycle, setPayrollCycle] = useState('');

    return (
        <UniDialog
            title={t('select_payment_cycle')}
            fullWidth
            maxWidth='sm'
            disableDefaultButtons
            open={props.openUpdateParollDialog}
            onClose={() => {
                props.handleUpdatePayrollDialogClose()
                setPayrollCycle('')
            }}
        >
            <FormControl
                variant="outlined"
                size="small"
                style={{width: '100%'}}
            >
                <InputLabel style={{fontSize: 13}}>{props.selectListGroup[0].label}</InputLabel>
                <Select
                    value={payrollCycle}
                    onChange={(event) => {
                        setPayrollCycle(event.target.value)
                    }}
                    id="selectpayrolldialog_payrollcycle_select"
                >
                    <MenuItem key={"currentPayrollCycles"}
                              value={props.selectListGroup[0]?.list?.currentPayrollCycles}>{t('current')}: {props.selectListGroup[0].list?.currentPayrollCycles}</MenuItem>
                    <MenuItem key={"nextPayrollCycle"}
                              value={props.selectListGroup[0].list?.nextPayrollCycle}>{t('next_pay')}: {props.selectListGroup[0].list?.nextPayrollCycle}</MenuItem>
                    {
                        props.paymentCycleSelectType === "summary" &&
                        props.selectListGroup[0]?.list?.lastThreeMonthPayrollCycles?.map((item) => {
                            return <MenuItem key={item}
                                             value={item}>{item}</MenuItem>
                        })
                    }
                </Select>
            </FormControl>
            <Grid container style={{marginTop: 60, marginBottom: 10}}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={3}>
                    <Button
                        variant='contained'
                        color="primary"
                        id="selectpayrolldialog_cancel_select"
                        onClick={() => {
                            props.handleUpdatePayrollDialogClose()
                            setPayrollCycle('')
                        }}
                    >
                        {t('cancel')}
                    </Button>
                </Grid>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={3}>
                    <Button
                        variant='contained'
                        color="secondary"
                        id="selectpayrolldialog_approve_select"
                        onClick={() => {
                            props.handleSubmitApprove(payrollCycle)
                        }}
                    >
                        {props.paymentCycleSelectType === "summary" ? t('submit') : t('approve')}
                    </Button>
                </Grid>
            </Grid>
        </UniDialog>
    );
}

export default SelectPayrollDialog;